export enum EICSTatus {
  PENDING = 'PEN',
  ACTIVE = 'ACT',
  RELEASED = 'REL',
  REJECTED = 'REJ',
  CANCELLED = 'CAN',
  TRANSFER_TO_PAPER = 'TTP'
}
